import * as React from "react";

import Table from './TableMutationResults';
import ResiduesTable from './ResiduesTable';
import AncestralsTable from './AncestralsTable';
import {
    columnsBtc,
    columnsLowRisk,
    columnsAllResidues,
    columnsAllResiduesNoFF,
    columnsHighRisk,
    columnsCombinedLowRisk,
    columnsCombinedHighRisk,
    columnsAncestralDesignTop,
    columnsAllResiduesTop,
    columnsAllResiduesDown,
    columnsAncestralDesigns,
    columnsLowRiskNoFF,
    columnsHighRiskNoFF,
    columnsCombinedLowRiskNoFF,
    columnsCombinedHighRiskNoFF,
    columnsAllResiduesDownNoFF
} from "../../../TableColumns";
import { IFinishedJobComponentPropsData, IFinishedJobComponentPropsFunctions } from "../props/IFinishedJobComponentProps";
import {Button, ButtonGroup} from 'reactstrap';
import {Helmet} from "react-helmet";

import {IInputComponentPropsData, IInputComponentPropsFunctions} from '../../InputPage/props/IInputComponentProps';
import {IInputJobSettings2PropsData, IInputJobSettings2PropsFunctions} from '../../InputPage/props/IInputJobSettings2Props';
import { ISummaryComponentPropsData, ISummaryComponentPropsFunctions } from "../../SummaryPage/props/ISummaryComponentProps";
import {IInputJobSettingsPropsData, IInputJobSettingsPropsFunctions} from '../../InputPage/props/IInputJobSettingsProps';
import {IJobComponentPropsData, IJobComponentPropsFunctions} from "../props/IJobComponentProps";
import {IJobMutationResult} from "../interfaces/IJobMutationResult"

import { LoadProteinParams, MolstarWrapper, renderProtein, SelectPositionProps,ViewerOptionsType } from "@loschmidt/molstar";
import { clientUrlPrefix } from "../../../settings";
import MolstarComponent from "./MolstarComponent";
import IJobInfo from "../interfaces/IJobInfo";
import { ll_fetch } from "../../../tools";

type IProps = IFinishedJobComponentPropsData & IFinishedJobComponentPropsFunctions&
IInputJobSettings2PropsData & IInputJobSettings2PropsFunctions &
IInputJobSettingsPropsData & IInputJobSettingsPropsFunctions&
IJobComponentPropsData & IJobComponentPropsFunctions & 
IInputComponentPropsData & IInputComponentPropsFunctions & IInputComponentPropsFunctions & 
ISummaryComponentPropsData & ISummaryComponentPropsFunctions & {match: {params: {jobId: string}}} & { history: any };

const ViewerOptions: ViewerOptionsType = {
    layoutIsExpanded: false,
    layoutShowControls: false,
    layoutShowRemoteState: false,
    layoutShowSequence: true,
    layoutShowLog: false,
    layoutShowLeftPanel: true,
    layoutShowStructure: true,
  
    viewportShowExpand: true,
    viewportShowControls: true,
    viewportShowSettings: false,
    viewportShowSelectionMode: true,
    viewportShowAnimation: true,
};

interface IState {
    selectedTable: any,
    proteins: any,
    showTable: number,

    btcMutations: any,
    lowEnergyMutations: any,
    highEnergyMutations: any,
    lowCombinedMutations: any,
    highCombinedMutations: any,
    ancestralDesigns: any,
    allResidues: any,

    mutations: any,
    selectedBTC: any,
    selectedLowRisk: any,
    selectedHighRisk: any,
    selectedCombinedLowRisk: any,
    selectedCombinedHighRisk: any,
    selectedAD: any,
    selectedAllResidues: any,

    data: any,
}

interface IResults {
    data: any
}

export default  class FinishedJobComponent extends React.Component<IProps, IState> {
    
    timeout: any = null;
    getJobId(props: IProps | null = null): string {
        if (props === null) {
            props = this.props;
        }
        return props.match.params.jobId;
    }

    viewer: MolstarWrapper;
    
    state: IState = {
        selectedTable: 0, //which result table should be displayed   
        proteins: [],
        showTable: 6,

        btcMutations:null,
        lowEnergyMutations:null,
        highEnergyMutations:null,
        lowCombinedMutations:null,
        highCombinedMutations:null,
        ancestralDesigns: null,
        allResidues:null,

        mutations:[],
        selectedBTC:[],
        selectedLowRisk:[],
        selectedHighRisk:[],
        selectedCombinedLowRisk: [],
        selectedCombinedHighRisk: [],
        selectedAD: [],
        selectedAllResidues: [],

        data: null,
    }

    async loadData() {
        if (this.props.finished) {
            this.props.updateJobStatus(true);
            const result = await ll_fetch(`/api/getAllData?jobId=${this.getJobId()}`);
            const data = await result.json();
            this.props.updateData(data);

        }
    }

    async initViewer(containerId: string) {
        this.viewer = await MolstarWrapper.init(containerId, ViewerOptions);
        this.viewer.setBackground(0xffffff);
    }


  /**
   * Load protein
   * @param props - [[`LoadProteinParams`]]
   */
  async loadProtein(props: LoadProteinParams) {
    const proteinState = this.state.proteins.find(s => s.label === props.label);
    if (proteinState && proteinState.selector) {
      proteinState.selector.show();
    } else {
      const proteinSelector = await renderProtein(this.viewer.plugin, {
        url: props.url,
        format: props.format,
        label: props.label,
        color: props.color
      })

      if (proteinSelector) this.setState({
        proteins: [...this.state.proteins, { ...props, selector: proteinSelector, ligands: [], tunnels: [], pockets: [] }]
        });
    }
  }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps: IProps) {
        if (this.props.jobId !== prevProps.jobId || this.props.finished !== prevProps.finished) {
            this.loadData();
        }
    }

    handleLoadBtcResults = () => {
        this.setState({ showTable: 0 });
        /*if (this.props.BTCmutations.length === 0){
            this.props.loadBtcResults(this.getJobId());
        }*/
       }
    handleLoadLowRiskResults = () => {
        this.setState({ showTable: 1 })

        /*if (this.props.LowRiskMutations.length === 0){
            this.props.loadLowRiskResults(this.getJobId());
        }*/
       }
    handleLoadHighRiskResults = () => {
        this.setState({ showTable: 2 })
        /*if (this.props.HighRiskMutations.length === 0){
            this.props.loadHighRiskResults(this.getJobId());
        }*/
    }
    handleLoadCombinedLowRiskResults = () => {
        this.setState({ showTable: 3 })
        /*if (this.props.CombinedLowRiskMutations.length === 0){
            this.props.loadCombinedLowRiskResults(this.getJobId());
        }*/
    }

    handleLoadCombinedHighRiskResults = () => {
        this.setState({ showTable: 4 })
        /*if (this.props.CombinedHighRiskMutations.length === 0){
            this.props.loadCombinedHighRiskResults(this.getJobId());
        }*/
    }

    handleLoadAncestralDesign = () => {
        this.setState({ showTable: 5 })
        /*if (this.props.ancestralDesigns.length === 0){
            this.props.loadAncestralDesigns(this.getJobId());
        }*/
    }

    handleAllResidues = () => {
        this.setState({ showTable: 6 })
        /*if (this.props.allResidues.length === 0){
            this.props.loadAllResiduesResults(this.getJobId());
        }*/
    }

    
    addToCustomMutant = (row) => {
       this.props.addCustomMutantMutations(row);
    }
    
    
    handleInfoReceived = (info: IJobInfo) => {
        if (info.status !== 5) {
            this.timeout = setTimeout(() => {
                this.props.loadJobInfo(this.getJobId(), false, this.handleInfoReceived);
            }, 5000);
        }
    }

    getResidueTable = () => {
        if(this.props.types["userDefined"]){
            return <Table
                key={6}
                data={this.props.allResidues}
                columns={this.props.types.noFF ? columnsAllResiduesNoFF : columnsAllResidues}
                inMutant={this.props.CustomMutantMutations}
                setSelectedRows={r => this.setState({ selectedAllResidues: r })}
                addToCustomMutant={this.addToCustomMutant}
                selected={this.state.selectedAllResidues}
                />;
        }
        else{
            return <ResiduesTable
                    key={6}
                    data={this.props.allResidues}
                    columns={[columnsAllResiduesTop, this.props.types.noFF ? columnsAllResiduesDownNoFF : columnsAllResiduesDown]}
                    inMutant={this.props.CustomMutantMutations}
                    setSelectedRows={r => this.setState({ selectedAllResidues: r })}
                    addToCustomMutant={this.addToCustomMutant}
                    selected={this.state.selectedAllResidues}
                    />;
        }
    }


    showTable = (Type) => {
        switch(Type) {
            case 0:
                    return <Table 
                    key={0}
                    data={this.props.BTCmutations}
                    columns={columnsBtc}
                    inMutant={this.props.CustomMutantMutations}
                    setSelectedRows={r => this.setState({ selectedBTC: r })}
                    addToCustomMutant={this.addToCustomMutant} 
                    selected={this.state.selectedBTC}
                    />;
            case 1:
                    return <Table
                    key={1}
                    data={this.props.LowRiskMutations}
                    columns={this.props.types.noFF ? columnsLowRiskNoFF : columnsLowRisk}
                    inMutant={this.props.CustomMutantMutations}
                    setSelectedRows={r => this.setState({ selectedLowRisk: r })} 
                    addToCustomMutant={this.addToCustomMutant} 
                    selected={this.state.selectedLowRisk}
                    />;
            case 2:
                    return <Table
                    key={2}
                    data={this.props.HighRiskMutations}
                    columns={this.props.types.noFF ? columnsHighRiskNoFF : columnsHighRisk}
                    inMutant={this.props.CustomMutantMutations}
                    setSelectedRows={r => this.setState({ selectedHighRisk: r })}
                    addToCustomMutant={this.addToCustomMutant}
                    selected={this.state.selectedHighRisk}
                    />;
            case 3:
                    return <Table
                    key={3}
                    data={this.props.CombinedLowRiskMutations}
                    columns={this.props.types.noFF ? columnsCombinedLowRiskNoFF : columnsCombinedLowRisk}
                    inMutant={this.props.CustomMutantMutations}
                    setSelectedRows={r => this.setState({ selectedCombinedLowRisk: r })}
                    addToCustomMutant={this.addToCustomMutant}
                    selected={this.state.selectedCombinedLowRisk}
                    />;
            case 4:
                    return <Table
                    key={4}
                    data={this.props.CombinedHighRiskMutations}
                    columns={this.props.types.noFF ? columnsCombinedHighRiskNoFF : columnsCombinedHighRisk}
                    inMutant={this.props.CustomMutantMutations}
                    setSelectedRows={r => this.setState({ selectedCombinedHighRisk: r })}
                    addToCustomMutant={this.addToCustomMutant}
                    selected={this.state.selectedCombinedHighRisk}
                    />;
            case 5:
                    return <AncestralsTable
                    key={5}
                    data={this.props.ancestralDesigns}
                    columns={[columnsAncestralDesignTop, columnsAncestralDesigns]}
                    inMutant={this.props.CustomMutantMutations}
                    setSelectedRows={r => this.setState({ selectedAD: r })}
                    addToCustomMutant={this.addToCustomMutant}
                    selected={this.state.selectedAD}
                    />;
            case 6:
                return this.getResidueTable();
            default:
    }}

    getRows = (Type, selectedBTC, selectedLowRisk, selectedHighRisk, selectedCombinedLowRisk, selectedCombinedHighRisk, selectedAD, selectedAllResidues) => {
        switch(Type) {
            case 0:    return selectedBTC;
            case 1:     return selectedLowRisk;
            case 2:     return selectedHighRisk;
            case 3:     return selectedCombinedLowRisk;
            case 4:     return selectedCombinedHighRisk;
            case 5:     return selectedAD;
            case 6:     return selectedAllResidues;
            default:
    }}
    
    render() {
        if (this.props.finished !== true) {
            return <div> <h1>Calculation is in progress</h1></div>;
        }
        return  <div>
            
            <MolstarComponent jobId={this.getJobId()} selectedRows={this.getRows(this.state.showTable, this.state.selectedBTC, this.state.selectedLowRisk, this.state.selectedHighRisk, this.state.selectedCombinedLowRisk, this.state.selectedCombinedHighRisk, this.state.selectedAD, this.state.selectedAllResidues)} ></MolstarComponent>
            
            <ButtonGroup variant="outlined" aria-label="outlined primary button group" style={{ width: "100%"}}>
            { !this.props.types.btc ? null :
            <Button {...this.state.showTable != 0 ? {className:"btnNotClicked"} :
                                {className:"btnClicked"}
                            }
                    onClick={this.handleLoadBtcResults} style={{ width: "100%"}}>Consensus</Button>
            }
            { !this.props.types.lowEnergy ? null :
            <Button {...this.state.showTable != 1 ? {className:"btnNotClicked"} :
                                {className:"btnClicked"}
                            }
                     onClick={this.handleLoadLowRiskResults} style={{ width: "100%"}}>Energy low risk</Button>
            }
            { !this.props.types.highEnergy ? null :
            <Button {...this.state.showTable != 2 ? {className:"btnNotClicked"} :
                                {className:"btnClicked"}
                            }
                    onClick={this.handleLoadHighRiskResults} style={{ width: "100%"}}>Energy high risk</Button>
            }
            { !this.props.types.lowCombined ? null :
            <Button {...this.state.showTable != 3 ? {className:"btnNotClicked"} :
                                {className:"btnClicked"}
                            }
                    onClick={this.handleLoadCombinedLowRiskResults} style={{ width: "100%"}}>Comb. low risk</Button>
            }
            { !this.props.types.highCombined ? null :
            <Button {...this.state.showTable != 4 ? {className:"btnNotClicked"} :
                                {className:"btnClicked"}
                            }
                    onClick={this.handleLoadCombinedHighRiskResults} style={{ width: "100%"}}>Comb. high risk</Button>
            }
            { !this.props.types.ancestrals ? null :
            <Button {...this.state.showTable != 5 ? {className:"btnNotClicked"} :
                                {className:"btnClicked"}
                            }
                    onClick={this.handleLoadAncestralDesign} style={{ width: "100%"}}>Ancestral design</Button>
            }
            <Button {...this.state.showTable != 6 ? {className:"btnNotClicked"} :
                                {className:"btnClicked"}
                            }
                    onClick={this.handleAllResidues} style={{ width: "100%"}}>All residues</Button>

            </ButtonGroup>

            {
                this.showTable(this.state.showTable)
            }
        </div>;
    }
}
